<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" class="d-flex">
        <div>
          <span
            :class="
              $vuetify.breakpoint.name == 'xs'
                ? 'title-style-mobile'
                : 'title-style'
            "
          >
            Gerenciar usuário
          </span>

          <p
            :class="
              $vuetify.breakpoint.name == 'xs'
                ? 'subtitle-style-mobile pb-8'
                : 'subtitle-style'
            "
          >
            Visualize e gerencie os usuários do AlertaDis.
          </p>
        </div>
        <v-spacer></v-spacer>
        <div>
          <v-btn
            @click="docStates('add')"
            :id="
              $vuetify.breakpoint.name == 'xs' ? 'btn-add-mobile' : 'btn-add'
            "
            color="accent lighten-1"
          >
            <v-icon class="pr-1" small>icon-alertadis-plus-circle</v-icon>
            Adicionar usuário
          </v-btn>
        </div>
      </v-col>
      <v-col lg="12" md="12" xl="12" v-show="success" class="pt-5">
        <v-alert dense text class="alert-style-success mr-2">
          <div class="d-flex">
            <div>
              <v-icon color="success darken-1"
                >icon-alertadis-info-circle</v-icon
              >
            </div>
            <div class="pl-2">
              <span class="success-alert-title">
                {{
                  alertController.tipoAlerta == 'add'
                    ? `Usuário adicionado.`
                    : `Usuário Editado.`
                }}
              </span>
              <br />
              <span class="success-alert-text">
                {{
                  alertController.tipoAlerta == 'add'
                    ? `O usuário ${alertController.userEmail} foi adicionado com sucesso.`
                    : `O usuário ${alertController.userEmail} foi editado com sucesso.`
                }}
              </span>
            </div>
            <v-spacer></v-spacer>
            <div :style="'padding: 8px 0px 8px 8px;'">
              <v-btn
                outlined
                id="btn-close"
                color="success darken-1"
                @click="closeAlert"
              >
                <v-icon class="pr-1" small>icon-alertadis-times-circle</v-icon>
                <span> Fechar </span>
              </v-btn>
            </div>
          </div>
        </v-alert>
      </v-col>
    </v-row>
    <v-row no-gutters class="pt-4">
      <v-col cols="12" class="d-flex">
        <div style="width: 300px">
          <div class="filter-input-group">
            <v-text-field
              v-model="search"
              id="search"
              placeholder="Nome, e-mail ou matrícula"
              outlined
              class="text-field-filter"
              color="accent"
              background-color="secondary"
            >
            </v-text-field>
            <label for="search">Buscar usuário</label>
          </div>
        </div>
        <div v-if="$vuetify.breakpoint.lgAndUp" class="pl-3">
          <div class="filter-input-group">
            <v-select
              color="accent"
              :items="departaments"
              item-text="name"
              item-value="name"
              return-object
              id="sector"
              v-model="selectionSector"
              outlined
              background-color="secondary"
              item-color="accent"
              class="text-field-filter"
              :menu-props="{
                maxHeight: 600,
              }"
            ></v-select>
            <label for="sector">Setor</label>
          </div>
        </div>
        <div v-if="$vuetify.breakpoint.lgAndUp">
          <div class="pl-3 filter-input-group">
            <v-select
              outlined
              id="status"
              background-color="secondary"
              color="accent"
              v-model="selectionStatus"
              :items="active"
              item-color="accent"
              class="text-field-filter"
            ></v-select>
            <label for="status">Status</label>
          </div>
        </div>
        <div v-if="$vuetify.breakpoint.lgAndUp" class="d-flex align-center">
          <div class="pl-8 text-field-filter checkbox-style">
            <v-checkbox
              color="accent"
              v-model="showAdmin"
              label="Apenas administradores"
            ></v-checkbox>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div v-if="$vuetify.breakpoint.lgAndUp" class="d-flex align-center">
          <div class="pt-4 ml-13">
            <v-btn
              outlined
              id="btn-clean"
              color="accent lighten-1"
              @click="clearFilter"
            >
              <span>Limpar filtros</span>
            </v-btn>
          </div>
        </div>
        <div v-if="$vuetify.breakpoint.mdAndDown" class="d-flex align-center">
          <v-btn color="transparent" depressed @click="dialogFilter = true">
            <v-icon color="accent lighten1">icon-alertadis-filter</v-icon>
            <span class="icon-filter-mobile pl-2">Filtrar</span>
          </v-btn>
        </div>
      </v-col>

      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="rows"
          :loading="loading"
          :search="search"
          :mobile-breakpoint="0"
          :items-per-page-options="listSize"
          :footer-props="{
            'items-per-page-text': 'Resultado por página',
            'show-current-page': true,
            'items-per-page-options': listSize,
          }"
          :header-props="{
            'sort-icon': 'icon-alertadis-angle-up',
          }"
          :options="{
            itemsPerPage: 10,
          }"
        >
          <template v-slot:[`item.actions`]="{item}">
            <v-btn
              icon
              @click="docStates('edit', item)"
              :disabled="onlySuperAdminsCanEditAdmins(item)"
            >
              <v-icon color="accent"> icon-alertadis-edit-alt </v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.name`]="{item}">
            <div class="pt-4">
              <a @click="setDialog(true, item)">
                <v-chip
                  v-if="isAdmin(item.groups)"
                  id="chip-admin"
                  color="secondary lighten-2"
                  label
                >
                  <v-icon left> icon-alertadis-shield-account </v-icon>
                  Administrador
                </v-chip>
                <br />

                <span class="title-style-table">
                  {{ item.name }}
                </span>
                <p>{{ item.email }}</p>
              </a>
            </div>
          </template>
          <template v-slot:[`item.active`]="{item}">
            <v-switch
              v-model="item.active"
              dense
              color="success"
              :label="item.active ? 'Ativo' : 'Inativo'"
              inset
              @click="editUser(item)"
            ></v-switch>
          </template>
          <template v-slot:[`item.acesso`]="{item}">
            <div v-if="item.acesso == 'Online agora'">
              <v-icon x-small> $onlineIcon</v-icon
              ><span class="pl-1">{{ item.acesso }}</span>
            </div>
            <span v-else> {{ item.acesso }}</span>
          </template>
          <template v-slot:[`item.departmentId`]="{item}">
            {{ departament(item) }}
          </template>

          <template v-slot:[`item.lastAccessAt`]="{item}">
            {{ lastAccessAt(item.lastAccessAt) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogFilter"
      scrollable
      max-width="312px"
      max-height="auto"
    >
      <v-card class="d-flex" color="secondary">
        <v-card-title class="title-filter"
          ><span id="title-filter">Filtros</span></v-card-title
        >
        <v-divider style="padding: 24px 0px 0px"></v-divider>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <div class="filter-input-group">
                  <v-select
                    color="accent"
                    id="sector"
                    :items="departaments"
                    item-text="name"
                    item-value="name"
                    return-object
                    v-model="selectionSectorFilter"
                    outlined
                    background-color="secondary"
                    item-color="accent"
                    class="text-field-filter"
                  ></v-select>
                  <label for="sector">Setor</label>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="filter-input-group pt-5">
                  <v-select
                    outlined
                    id="status"
                    color="accent"
                    background-color="secondary"
                    item-color="accent"
                    v-model="selectionStatusFilter"
                    :items="active"
                    class="text-field-filter"
                  ></v-select>
                  <label for="status">Status</label>
                </div>
              </v-col>
              <v-col cols="12" class="filter-input-group">
                <v-checkbox
                  color="accent"
                  class="text-field-filter pr-2"
                  label="Apenas administradores"
                  v-model="showAdminFilter"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="accent"
            id="btn-filter"
            class="pr-5"
            @click="filterDialog"
          >
            <span>Filtrar </span>
          </v-btn>
          <v-btn id="btn-filter-clear" @click="clearFilter">
            <span>Limpar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import UserSevice from '@/api/rest-administrative/user.service';
import {snackbar} from '@/core/controller/snackbar_controller';
import {mapGetters} from 'vuex';

export default {
  props: {
    controller: {
      type: Object,
    },

    loading: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    rows: {
      type: Array,
      required: true,
      default: () => [],
    },
    departaments: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      selectionStatus: null,
      search: '',
      items: [],
      dialogFilter: false,
      selectionStatusFilter: null,
      showAdminFilter: false,
      showAdmin: false,
      listSize: [10, 30, 50, 100],
      alertController: {},
      success: false,
      userType: '',
      selectionSector: {
        name: 'Todos',
        id: 0,
      },
      selectionSectorFilter: {
        name: 'Todos',
        id: 0,
      },
      active: [
        {text: 'Todos', value: null},
        {text: 'Ativo', value: true},
        {text: 'Inativo', value: false},
      ],
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    headers() {
      return [
        {text: 'Usuário', value: 'name'},
        {
          text: 'Matrícula',
          value: 'originalid',
          align: this.$vuetify.breakpoint.name == 'xs' ? ' d-none' : '',
        },
        {
          text: 'Setor',
          value: 'departmentId',
          filter: this.sectorFilter,
          align: this.none(),
        },
        {
          text: 'Último acesso',
          value: 'lastAccessAt',
          filterable: false,
          align: this.none(),
        },
        {
          text: 'Status',
          value: 'active',
          filter: this.statusFilter,
          align: this.$vuetify.breakpoint.name == 'xs' ? ' d-none' : '',
        },
        {
          text: 'email',
          value: 'email',
          sortable: false,
          align: ' d-none',
        },
        {
          text: 'Admin',
          value: 'admin',
          sortable: false,
          filter: this.adminFilter,
          align: ' d-none',
        },
        {text: 'Ações', value: 'actions', sortable: false},
      ];
    },
    isSuperAdmin() {
      return this.currentUser.attributes.roles.includes('AlertaDIS_SUPER_USER');
    },
  },

  methods: {
    setDialog(dialog, item) {
      this.$emit('setDialog', dialog, item);
    },
    docStates(docState, item) {
      this.$emit('docStates', docState, item);
    },

    sectorFilter(value) {
      if (this.selectionSector.name === 'Todos') {
        return true;
      }

      return value === this.selectionSector.id;
    },

    statusFilter(value) {
      if (this.selectionStatus === null) {
        return true;
      }

      return value === this.selectionStatus;
    },

    adminFilter(value) {
      if (this.showAdmin) {
        return value === this.showAdmin;
      }

      return true;
    },
    none() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return ' d-none';
        case 'sm':
          return ' d-none';
        case 'md':
          return ' d-none';
        default:
          return '';
      }
    },

    departament(item) {
      const departament = this.departaments.find(
        (element) => element.id === item.departmentId,
      );
      return departament ? departament.name : '';
    },

    filterDialog() {
      this.selectionSector = this.selectionSectorFilter;
      this.selectionStatus = this.selectionStatusFilter;
      this.showAdmin = this.showAdminFilter;
      this.dialogFilter = false;
    },

    clearFilter() {
      this.search = '';
      this.selectionSector = {
        name: 'Todos',
        id: 0,
      };
      this.selectionStatus = null;
      this.selectionSectorFilter = {
        name: 'Todos',
        id: 0,
      };
      this.selectionStatusFilter = null;
      this.dialogFilter = false;
      this.showAdmin = false;
    },

    isAdmin(groups) {
      if (groups.length == 2) {
        return true;
      }

      if (groups[0] === 'ALERTADIS_ADMINS') {
        return true;
      }
      return false;
    },

    lastAccessAt(dateTime) {
      if (dateTime) {
        const dateAndTime = new Date(dateTime);
        let today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();
        today = dd + '/' + mm + '/' + yyyy;
        const date = `${String(dateAndTime.getDate()).padStart(
          2,
          '0',
        )}/${String(dateAndTime.getMonth() + 1).padStart(
          2,
          '0',
        )}/${dateAndTime.getFullYear()}`;

        const hours = `${dateAndTime.getHours()}:${dateAndTime.getMinutes()}`;
        if (today == date) {
          const t = new Date();
          const diferenca = new Date(dateAndTime - t);
          let resultado = diferenca.getUTCHours();

          if (resultado == 24) {
            return 'Online agora';
          }
          if (resultado == 23) {
            return `${60 - diferenca.getMinutes()}m atrás`;
          }
          return `${23 - resultado}h atrás`;
        }

        return `${date} ás ${hours}`;
      }

      return '';
    },

    closeAlert() {
      this.success = false;
    },
    async editUser(item) {
      try {
        const payload = {
          acronym: item.acronym || '',
          active: item.active,
          departamentId: item.departmentId,
          name: item.name,
          admin: item.admin,
          originalid: item.originalid,
        };
        await UserSevice.putUser(item.id, payload);
        this.$emit('alertUser', true, item.email, 'edit');
        this.success = true;
      } catch (error) {
        snackbar.show({
          type: 'error',
          title: error.title,
          message: error.message,
          timeout: 7000,
        });
      }
    },
    onlySuperAdminsCanEditAdmins(item) {
      if (!this.isSuperAdmin && item.admin) return true;
      return false;
    },
  },

  mounted() {
    this.alertController = this.controller;
    this.userType = this.$store.getters.currentUser.attributes.roles;
    this.success = this.alertController.alert;
  },
};
</script>

<style lang="scss">
.mdi-chevron-up::before {
  content: '\F0143';
  color: var(--v-accent-lighten1) !important;
}

.theme--dark.v-sheet {
  background-color: var(--v-secondary-base) !important;
  border-color: var(--v-accent-lighten1) !important;
}

tbody {
  tr:hover {
    background-color: var(--v-secondary-lighten4) !important;
  }
}
</style>

<style scoped>
label {
  order: -1;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;

  color: var(--v-primary-base);
}
.v-input:focus-within + label {
  color: var(--v-accent-lighten1) !important;
}
.mdi-chevron-up::before {
  content: '\F0143';
  color: var(--v-accent-base);
}
.filter-input-group {
  display: flex;
  flex-direction: column;
  top: 22px;
}
.title-style-table {
  color: var(--v-accent-lighten1) !important;
}
.title-style {
  width: 310px;
  height: 45px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 46px;
}

.title-style-mobile {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 33px;
  /* identical to box height */

  letter-spacing: 0.25px;
  color: var(--v-primary-base) !important;
}
.subtitle-style {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  letter-spacing: 0.15px;
  height: 21px;
}

.subtitle-style-mobile {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.15px;
  height: 21px;
}
.checkbox-style {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  /* identical to box height, or 129% */

  letter-spacing: 0.75px;
}
.theme--dark.v-data-table {
  background-color: var(--v-secondary-base) !important;

  border: 2px solid rgba(245, 130, 30, 0.1);
  border-radius: 8px;
  margin: 24px 0px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.theme--dark.v-data-table >>> th {
  background: var(--v-secondary-lighten2) !important;
  border-radius: 8px 8px 0px 0px;
}
.theme--dark.v-data-table
  >>> tbody
  >>> tr:hover:not(.v-data-table__expanded__content) {
  background: var(--v-secondary-lighten1) !important;
}

.theme--dark.v-data-table >>> .v-data-footer {
  background: var(--v-secondary-lighten2) !important;
  border-radius: 0px 0px 8px 8px;
}

.text-field-filter {
  border-radius: 8px;
  min-width: 255.6;
  height: 52px;
}

.alert-style-success {
  border-radius: 8px;
  color: var(--v-success-darken1);
  background-color: var(--v-success-lighten1) !important;
}

.success-alert-title {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}
.success-alert-text {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  /* identical to box height, or 129% */

  letter-spacing: 0.75px;
}

#btn-close {
  border: 1px solid var(--v-success-darken1) !important;
  border-radius: 8px;
  width: 95px;
  height: 34px;
  text-transform: none;
}

#btn-add {
  height: 52px;
  top: 7px;
  border-radius: 8px;
  text-transform: none;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  /* identical to box height, or 129% */

  letter-spacing: 0.75px;
}
#btn-clean {
  text-transform: none;
  border-radius: 8px;
  height: 50px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.icon-filter-mobile {
  width: 41px;
  height: 18px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-accent-lighten1);
}

#btn-filter {
  padding: 16px 20px;
  width: 88px;
  height: 50px;
  border-radius: 8px;
  text-transform: none;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}
#btn-filter-clear {
  border-radius: 8px;
  padding: 16px 20px;
  background: var(--v-secondary-base) !important;
  width: 88px;
  height: 50px;
  text-transform: none;
  color: var(--v-accent-lighten1) !important;
  border: 2px solid var(--v-accent-lighten1) !important;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

#switch-status {
  border: 1px solid var(--v-success-success) !important;
  box-sizing: border-box;
  border-radius: 16px;
}

#title-filter {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 27px;
}

#btn-add-mobile {
  padding: 8px 16px 8px 8px;
  border-radius: 8px;
  height: 34px;
  width: 100%;
  text-transform: none;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  /* identical to box height, or 129% */

  letter-spacing: 0.75px;
}

#chip-admin {
  border-radius: 4px;
}

.v-dialog > .v-card > .v-card__title {
  background: var(--v-secondary-lighten2) !important;
}

.v-dialog > .v-card > .v-card__actions {
  background: var(--v-secondary-lighten2) !important;
}
</style>
